
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/registration",
      function () {
        return require("private-next-pages/user/registration.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/registration"])
      });
    }
  